import axios from "axios";
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const token = localStorage.getItem('token');




export const createEvent = async (eventData) => {
  const token = localStorage.getItem("token");

  try {
    const response = await fetch(`${BACKEND}/createevent`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, // Include the Bearer token for authentication
      },
      body: JSON.stringify(eventData), // Convert eventData to a JSON string
    });

    if (!response.ok) {
      const errorData = await response.json(); // Parse error response
      throw new Error(errorData.message || "Failed to create event");
    }

    return await response.json(); // Parse and return the JSON response
  } catch (error) {
    console.error("Error creating event:", error);
    throw error;
  }
};

export const getAllEvents = async () => {
  try {
    const response = await axios.get(`${BACKEND}/getAllEvents`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
        },
      }
    ); // Change URL based on your backend
    return response.data;
  } catch (error) {
    console.error("Error fetching events:", error);
    throw error;
  }
};
export const toggleRegistrationStatus = async (eventId) => {
  try {
    const response = await axios.put(
      `${BACKEND}/toggleRegistrationStatus`,
      { eventId }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching events:", error);
    throw error;
  }
};

export const deleteEvent = async (eventId) => {
  try {
    const response = await axios.delete(`${BACKEND}/eventDelete/${eventId}`);
    return response.data;
  } catch (error) {
    throw new Error("Failed to delete event");
  }
};

export const updateEvent = async (eventId, eventData) => {
  const response = await fetch(`${BACKEND}/updateEvent/${eventId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(eventData),
  });

  if (!response.ok) {
    throw new Error('Failed to update event');
  }

  return response.json();
};